export default __webpack_public_path__ + "static/program_ruralnog_razvoja-f0e250abd3484ab1ee0f45c7c757a8ff.pdf";